enum DetailedSheetStatusesEnum {
  INCOMPLETE = 'INCOMPLETE',
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
}

export default DetailedSheetStatusesEnum;
